import { render } from "./OthersForm.vue?vue&type=template&id=4ffa1c91&scoped=true&ts=true"
import script from "./OthersForm.vue?vue&type=script&lang=ts"
export * from "./OthersForm.vue?vue&type=script&lang=ts"

import "./OthersForm.vue?vue&type=style&index=0&id=4ffa1c91&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ffa1c91"]])

export default __exports__